import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { IncomeExpensesServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';

/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
    selector: 'page-expenses-create-data.html',
    templateUrl: 'expenses-create-data.html',
})
export class ExpensesCreateDataPage {
    public form: FormGroup;
    expenses_uid: any;
    update_state: boolean = false;
    base: any;
    tax: any;
    total: any;
    irpf_percentage: any;
    irpf_amount: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public fb: FormBuilder,
        public globals: Globals,
        private toastCtrl: ToastController,
        public incomeExpensesServices: IncomeExpensesServices,
        private alertCtrl: AlertController,
        private providersServices: ProvidersServices,
        public translate: TranslateService) {


        //Params
        this.update_state = this.navParams.get('update_state');
        this.expenses_uid = this.navParams.get('expenses_uid');

        //d
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cargando-proveedores')
        });
        loadingPopup.present();
        this.providersServices.getListProviders(this.globals.restaurant_uid);
        loadingPopup.dismiss();

        this.base = this.navParams.get('base') || 0;
        this.tax = this.navParams.get('tax') || 0;
        this.total = this.navParams.get('total') || 0;
        // Inicializar IRPF: si no existe o es null/undefined, usar 0
        var irpf_perc = this.navParams.get('irpf_percentage');
        var irpf_amt = this.navParams.get('irpf_amount');
        this.irpf_percentage = (irpf_perc !== null && irpf_perc !== undefined) ? irpf_perc : 0;
        this.irpf_amount = (irpf_amt !== null && irpf_amt !== undefined) ? irpf_amt : 0;

        // Inicializar formulario siempre con irpf_percentage
        if (this.update_state) {
            this.form = fb.group({
                concept: [this.navParams.get('concept'), Validators.compose([Validators.required])],
                number: [this.navParams.get('number')],
                date: [this.incomeExpensesServices.timestampToDate(this.navParams.get('date'))],
                base: [this.base],
                tax: [this.tax],
                total: [this.total],
                business_name: [this.navParams.get('business_name')],
                provider: [this.navParams.get('provider_uid') + ',;,' + this.navParams.get('business_name')],
                payment_method: [this.navParams.get('payment_method')],
                category: [this.navParams.get('category')],
                payment: [this.navParams.get('payment')],
                irpf_percentage: [this.irpf_percentage]
            });
            // Recalcular irpf_amount y total para asegurar que estén correctos
            // Esto es importante porque gastos antiguos pueden tener totales calculados sin IRPF
            this.calculateRow();
            this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Expenses - View', this.globals.restaurant.email, 'View', 'View Expenses', 'Income/Expenses', '');
        } else {
            this.base = 0;
            this.tax = 0;
            this.total = 0;
            this.irpf_percentage = 0;
            this.irpf_amount = 0;
            //
            this.form = fb.group({
                concept: ['', Validators.compose([Validators.required])],
                number: [0],
                date: [''],
                base: [0],
                tax: [0],
                total: [0],
                business_name: [''],
                provider: [''],
                payment_method: ['giro'],
                category: [],
                payment: [false],
                irpf_percentage: [0]
            });
        }




    }

    calculateRow() {
        // Asegurar que el control irpf_percentage existe (medida de seguridad)
        if (!this.form.get('irpf_percentage')) {
            this.form.addControl('irpf_percentage', new FormControl(0));
        }
        
        // Obtener valores del formulario de forma segura
        var baseControl = this.form.get('base');
        var taxControl = this.form.get('tax');
        var irpfControl = this.form.get('irpf_percentage');
        
        this.base = baseControl ? (parseFloat(baseControl.value) || 0) : 0;
        this.tax = taxControl ? (parseFloat(taxControl.value) || 0) : 0;
        this.irpf_percentage = irpfControl ? (parseFloat(irpfControl.value) || 0) : 0;

        // Validar que los valores sean válidos
        if (this.base < 0) this.base = 0;
        if (this.tax < 0) this.tax = 0;
        if (this.irpf_percentage < 0) this.irpf_percentage = 0;
        if (this.irpf_percentage > 100) this.irpf_percentage = 100;

        // Calcular IRPF (siempre inicializar)
        this.irpf_amount = (this.base * this.irpf_percentage) / 100;
        if (isNaN(this.irpf_amount) || this.irpf_amount < 0) {
            this.irpf_amount = 0;
        }
        
        // Base después de IRPF (no puede ser negativa)
        var base_after_irpf = this.base - this.irpf_amount;
        if (isNaN(base_after_irpf) || base_after_irpf < 0) {
            base_after_irpf = 0;
        }
        
        // Calcular total: base después de IRPF + IVA sobre esa base
        this.total = base_after_irpf + ((base_after_irpf * this.tax) / 100);
        if (isNaN(this.total) || this.total < 0) {
            this.total = 0;
        }
        
        // Actualizar valores en el formulario
        this.form.patchValue({
            total: this.total
        }, { emitEvent: false });

    }

    submit() {
        if (this.form.valid && this.form.value.provider != '') {
            if (!this.update_state) {
                this.insert();
            } else {
                this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-completa-datos-continuar'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    insert() {
        // Asegurar que los cálculos estén actualizados antes de guardar
        this.calculateRow();
        
        var pro = this.form.value.provider.split(',;,');
        var p_name = pro[1];
        var p_uid = pro[0];
        
        // Asegurar que los valores IRPF estén inicializados y correctos
        var irpf_perc = parseFloat(this.form.value.irpf_percentage) || 0;
        var irpf_amt = parseFloat(this.irpf_amount) || 0;
        
        this.incomeExpensesServices.afs.collection('expenses').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'number': this.form.value.number,
            'date': new Date(this.form.value.date),
            'concept': this.form.value.concept,
            'base': parseFloat(this.form.value.base) || 0,
            'tax': parseFloat(this.form.value.tax) || 0,
            'total': parseFloat(this.form.value.total) || 0,
            'business_name': p_name,
            'provider_uid': p_uid,
            'payment_method': this.form.value.payment_method,
            'category': this.form.value.category || '',
            'payment': this.form.value.payment || false,
            'irpf_percentage': irpf_perc,
            'irpf_amount': irpf_amt

        }).then(doc => {
            this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Expenses - Create', this.globals.restaurant.email, 'Create/Update', 'Create expenses', 'Income/Expenses', this.form.value.number);
            this.navCtrl.pop();

        });
    }

    update() {
        // Asegurar que los cálculos estén actualizados antes de guardar
        this.calculateRow();
        
        var pro = this.form.value.provider.split(',;,');
        var p_name = pro[1];
        var p_uid = pro[0];

        // Asegurar que los valores IRPF estén inicializados y correctos
        var irpf_perc = parseFloat(this.form.value.irpf_percentage) || 0;
        var irpf_amt = parseFloat(this.irpf_amount) || 0;

        this.incomeExpensesServices.afs.collection('expenses').doc(this.expenses_uid).update({
            'number': this.form.value.number,
            'date': new Date(this.form.value.date),
            'concept': this.form.value.concept,
            'base': parseFloat(this.form.value.base) || 0,
            'tax': parseFloat(this.form.value.tax) || 0,
            'total': parseFloat(this.form.value.total) || 0,
            'business_name': p_name,
            'provider_uid': p_uid,
            'payment_method': this.form.value.payment_method,
            'category': this.form.value.category || '',
            'payment': this.form.value.payment || false,
            'irpf_percentage': irpf_perc,
            'irpf_amount': irpf_amt
        }).then(() => {
            this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Expenses - Update', this.globals.restaurant.email, 'Create/Update', 'Update expenses', 'Income/Expenses', this.form.value.number);
            this.navCtrl.pop();
        });
    }

    delete() {

        let alert = this.alertCtrl.create({

            title: this.translate.instant('general-eliminar-gasto'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Expenses - Delete', this.globals.restaurant.email, 'Delete', 'Delete expenses', 'Income/Expenses', this.form.value.number);
                        this.incomeExpensesServices.delete(this.expenses_uid, 'expenses');
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }
    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.pop();
        loadingPopup.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/income-expenses/expenses-create/expenses-create-data/expenses-create-data.ts